import { parseISO, format } from "date-fns";
import { es, enGB } from "date-fns/esm/locale";
import useWindowDimensions from "hoc/useWindowDimensions";
import { MyCarousel } from "./myCarousel";

export const CardImage = ({
  id,
  title,
  date,
  images,
  onClick,
  locale,
  state,
  showDraft,
}) => {
  const { height } = useWindowDimensions();

  const getHeight = () => {
    if (height - 200 > 760 && height - 200 < 900) {
      return height - 200;
    } else {
      return 760;
    }
  };

  const showRibbon = () => {
    if (state === "DRAFT" || state === "PUBLISH_WITH_DRAFT") {
      if (showDraft) {
        return true;
      }
    }
    return false;
  };

  return (
    <div
      className="cardImage-container"
      onClick={(e) => {
        onClick(e, id);
      }}
      style={{ maxHeight: getHeight() }}
    >
      <div className="image-container">
        {showRibbon() && (
          <div
            className={`ribbon ribbon-top-left ${
              state === "PUBLISH_WITH_DRAFT" ? "ribbon-green" : ""
            }`}
          >
            <span>DRAFT</span>
          </div>
        )}
        {images.length > 1 ? (
          <MyCarousel images={images} />
        ) : (
          <>
            <div className="image-not-carrusel">
              {showRibbon() && (
                <div
                  className={`ribbon ribbon-top-left ${
                    state === "PUBLISH_WITH_DRAFT" ? "ribbon-green" : ""
                  }`}
                >
                  <span>DRAFT</span>
                </div>
              )}
              <img src={images[0]} alt={"news background"} />
            </div>
          </>
        )}
      </div>
      <div className="text-container">
        <p className="title">{title}</p>
        <p className="date">
          {locale === "es"
            ? format(parseISO(date), "dd LLLL, yyyy", {
                locale: es,
              })
            : format(parseISO(date), "LLLL dd, yyyy", {
                locale: enGB,
              })}
        </p>
      </div>
    </div>
  );
};
